$(document).on('turbolinks:load', function() {
  // Show modal if there are unread notifications
  if ($('#admin-notifications-modal').length && $('.notification-link').length > 0) {
    $('#admin-notifications-modal').modal('show');
  }

  // Handle clicking on notification links
  $('.notification-link').on('click', function() {
    var notificationId = $(this).data('notification-id');
    // You can optionally mark individual notifications as read here
    // by making an AJAX call to your notifications endpoint
  });
});
